// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/modules/home/home.less
 ** module id = 13
 ** module chunks = 0
 **/